import React, { useState, useEffect } from "react";
import cmsApi from "../../services/cmsApi";

const defaultBoardMembers = [
        {
            fullName: "Bi. Felista Mangalu",
            position: "Mwenyekiti wa Bodi",
            yearsInRole: "Board Chairperson",
            bio: "Bi. Felista Mangalu serves as the Chairperson of the Advisory Board, bringing extensive leadership experience and strategic vision to guide JRIIT's mission. Her commitment to educational excellence and institutional development has been instrumental in shaping the college's growth and impact in Tanzania's technical education sector.",
            photo: "https://ui-avatars.com/api/?name=Bi.+Felista+Mangalu&background=5d0470&color=ffffff&size=200",
            accentColor: "custom-pink",
        },
        {
            fullName: "Bw. Lesneth Lukumay",
            position: "Katibu wa Bodi",
            yearsInRole: "Board Secretary",
            bio: "Bw. Lesneth Lukumay serves as the Board Secretary, ensuring effective communication and documentation of board proceedings. His organizational skills and attention to detail support the board's decision-making processes and maintain institutional governance standards.",
            photo: "https://ui-avatars.com/api/?name=Bw.+Lesneth+Lukumay&background=fca903&color=ffffff&size=200",
            accentColor: "gold",
        },
        {
            fullName: "Bw. Erick Rowberg",
            position: "Mjumbe",
            yearsInRole: "Board Member",
            bio: "Bw. Erick Rowberg brings valuable expertise as a board member, contributing to strategic planning and policy development. His diverse background and professional experience enhance the board's ability to guide JRIIT's educational mission and institutional growth.",
            photo: "https://ui-avatars.com/api/?name=Bw.+Erick+Rowberg&background=5d0470&color=ffffff&size=200",
            accentColor: "custom-pink",
        },
        {
            fullName: "Dkt. Yusuph B Mhando",
            position: "Mjumbe",
            yearsInRole: "Board Member",
            bio: "Dkt. Yusuph B Mhando contributes his academic and professional expertise as a board member. His insights into educational development and institutional management help guide JRIIT's strategic direction and ensure alignment with national educational goals.",
            photo: "https://ui-avatars.com/api/?name=Dkt.+Yusuph+B+Mhando&background=fca903&color=ffffff&size=200",
            accentColor: "gold",
        },
        {
            fullName: "Dkt. Godfrey Komba",
            position: "Mjumbe",
            yearsInRole: "Board Member",
            bio: "Dkt. Godfrey Komba brings his professional expertise to the advisory board, contributing to policy development and strategic planning. His commitment to educational excellence supports JRIIT's mission to provide quality technical education.",
            photo: "https://ui-avatars.com/api/?name=Dkt.+Godfrey+Komba&background=5d0470&color=ffffff&size=200",
            accentColor: "custom-pink",
        },
        {
            fullName: "Dkt. Neduvoto P Mollel",
            position: "Mjumbe",
            yearsInRole: "Board Member",
            bio: "Dkt. Neduvoto P Mollel serves as a board member, bringing his academic and professional background to support JRIIT's educational mission. His expertise contributes to the board's strategic decision-making and institutional development initiatives.",
            photo: "https://ui-avatars.com/api/?name=Dkt.+Neduvoto+P+Mollel&background=fca903&color=ffffff&size=200",
            accentColor: "gold",
        },
        {
            fullName: "Shabani Shabani",
            position: "Mjumbe mwalikwa",
            yearsInRole: "Invited Board Member",
            bio: "Shabani Shabani serves as an invited board member, bringing external perspective and expertise to the advisory board. His contributions help ensure JRIIT's programs remain relevant to industry needs and community development goals.",
            photo: "https://ui-avatars.com/api/?name=Shabani+Shabani&background=5d0470&color=ffffff&size=200",
            accentColor: "custom-pink",
        },
        {
            fullName: "Bakari Ayubu",
            position: "Mjumbe mwalikwa",
            yearsInRole: "Invited Board Member",
            bio: "Bakari Ayubu serves as an invited board member, contributing his professional experience and community insights to the advisory board. His perspective helps ensure JRIIT's programs align with local development needs and industry requirements.",
            photo: "https://ui-avatars.com/api/?name=Bakari+Ayubu&background=fca903&color=ffffff&size=200",
            accentColor: "gold",
        },
    ];

const BoardOfTrustees = () => {
    const [isVisible, setIsVisible] = useState(false);
    const [animatedCards, setAnimatedCards] = useState([]);
    const [boardMembers, setBoardMembers] = useState(defaultBoardMembers);

    useEffect(() => {
        const timer = setTimeout(() => setIsVisible(true), 100);

        const fetchContent = async () => {
            try {
                const result = await cmsApi.getPageComponents("trustees");
                if (result && result.success && result.components) {
                    const membersComp = result.components.find(
                        (c) => c.componentName === "board-members"
                    );
                    if (membersComp && membersComp.settings) {
                        try {
                            const parsed = JSON.parse(membersComp.settings);
                            if (Array.isArray(parsed) && parsed.length > 0) {
                                setBoardMembers(parsed);
                            }
                        } catch {
                            // keep defaults
                        }
                    }
                }
            } catch (e) {
                console.error("Failed to fetch trustees CMS content:", e);
            }
        };
        fetchContent();

        return () => clearTimeout(timer);
    }, []);

    useEffect(() => {
        const animateCards = () => {
            boardMembers.forEach((_, index) => {
                setTimeout(
                    () => {
                        setAnimatedCards((prev) => [...prev, index]);
                    },
                    400 + index * 200,
                );
            });
        };
        const cardsTimer = setTimeout(animateCards, 600);
        return () => clearTimeout(cardsTimer);
    }, [boardMembers]);

    return (
        <div className="min-h-screen bg-white py-12 px-4 relative overflow-hidden">
            {/* Background Pattern */}
            <div className="absolute inset-0 opacity-10">
                <div className="absolute inset-0 bg-net-pattern"></div>
            </div>

            {/* Golden Side Accent */}
            <div className="fixed right-0 top-0 w-2 h-full bg-gradient-to-b from-gold via-gold to-yellow-600 opacity-80 z-10"></div>
            <div className="fixed right-2 top-1/2 transform -translate-y-1/2 -rotate-90 z-20">
                <h3 className="text-gold font-bold tracking-widest text-sm">
                    ADVASORY BOARD
                </h3>
            </div>

            <div className="container mx-auto max-w-7xl relative z-10">
                {/* Header Section */}
                <div
                    className={`mb-16 transition-all duration-1000 ease-out ${isVisible
                        ? "opacity-100 translate-y-0"
                        : "opacity-0 -translate-y-10"
                        }`}
                >
                    <div className="flex items-center mb-8">
                        <div className="w-1 h-16 bg-gradient-to-b from-gold to-custom-pink mr-6"></div>
                        <div>
                            <h1 className="font-bold text-gray-800 text-3xl sm:text-4xl md:text-5xl lg:text-6xl tracking-tight">
                                Advisory Board
                            </h1>
                            <p className="text-gold text-lg mt-2">
                                Leadership Excellence at JRIIT
                            </p>
                        </div>
                    </div>
                </div>

                {/* Board Members Layout - Magazine Style */}
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12">
                    {boardMembers.map((member, index) => (
                        <div
                            key={index}
                            className={`relative group transition-all duration-700 ease-out ${animatedCards.includes(index)
                                ? "opacity-100 translate-x-0"
                                : `opacity-0 ${index % 2 === 0 ? "-translate-x-10" : "translate-x-10"}`
                                }`}
                            style={{ transitionDelay: `${index * 200}ms` }}
                        >
                            {/* Member Card */}
                            <div className="relative bg-white rounded-2xl p-6 md:p-8 border border-gray-200 hover:border-gold/50 transition-all duration-500 hover:shadow-xl group shadow-lg">
                                {/* Accent Line */}
                                <div
                                    className={`absolute left-0 top-0 w-1 h-full rounded-l-2xl bg-gradient-to-b ${member.accentColor === "gold"
                                        ? "from-gold to-yellow-600"
                                        : "from-custom-pink to-purple-600"
                                        } group-hover:w-2 transition-all duration-300`}
                                ></div>

                                <div className="flex flex-col sm:flex-row items-start gap-6">
                                    {/* Hexagonal Photo Frame */}
                                    <div className="relative flex-shrink-0 mx-auto sm:mx-0">
                                        <div className="relative w-32 h-36 sm:w-40 sm:h-44">
                                            {/* Hexagon Background */}
                                            <div
                                                className={`absolute inset-0 transform rotate-0 transition-all duration-500 group-hover:rotate-6 group-hover:scale-105`}
                                            >
                                                <svg viewBox="0 0 100 115" className="w-full h-full">
                                                    <defs>
                                                        <clipPath id={`hexClip${index}`}>
                                                            <polygon points="50,5 85,25 85,75 50,95 15,75 15,25" />
                                                        </clipPath>
                                                        <linearGradient
                                                            id={`hexGrad${index}`}
                                                            x1="0%"
                                                            y1="0%"
                                                            x2="100%"
                                                            y2="100%"
                                                        >
                                                            <stop
                                                                offset="0%"
                                                                stopColor={
                                                                    member.accentColor === "gold"
                                                                        ? "#fca903"
                                                                        : "#5d0470"
                                                                }
                                                                stopOpacity="0.3"
                                                            />
                                                            <stop
                                                                offset="100%"
                                                                stopColor={
                                                                    member.accentColor === "gold"
                                                                        ? "#f59e0b"
                                                                        : "#7c3aed"
                                                                }
                                                                stopOpacity="0.1"
                                                            />
                                                        </linearGradient>
                                                    </defs>
                                                    <polygon
                                                        points="50,5 85,25 85,75 50,95 15,75 15,25"
                                                        fill={`url(#hexGrad${index})`}
                                                        stroke={
                                                            member.accentColor === "gold"
                                                                ? "#fca903"
                                                                : "#5d0470"
                                                        }
                                                        strokeWidth="2"
                                                        className="drop-shadow-lg"
                                                    />
                                                </svg>
                                            </div>

                                            {/* Photo */}
                                            <div className="absolute inset-2 rounded-lg overflow-hidden">
                                                <img
                                                    src={member.photo}
                                                    alt={member.fullName}
                                                    className="w-full h-full object-cover transition-all duration-500 group-hover:scale-110"
                                                    style={{
                                                        clipPath:
                                                            "polygon(25% 5%, 75% 5%, 95% 25%, 95% 75%, 75% 95%, 25% 95%, 5% 75%, 5% 25%)",
                                                    }}
                                                    onError={(e) => {
                                                        e.target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(member.fullName)}&background=random&size=200`;
                                                    }}
                                                />
                                            </div>

                                            {/* Hexagon Glow Effect */}
                                            <div
                                                className={`absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 ${member.accentColor === "gold"
                                                    ? "bg-gold/10"
                                                    : "bg-custom-pink/10"
                                                    } blur-xl rounded-full`}
                                            ></div>
                                        </div>
                                    </div>

                                    {/* Content */}
                                    <div className="flex-1 text-center sm:text-left">
                                        {/* Name */}
                                        <h3
                                            className={`text-2xl md:text-3xl font-bold mb-2 transition-colors duration-300 ${member.accentColor === "gold"
                                                ? "text-gold group-hover:text-yellow-400"
                                                : "text-custom-pink group-hover:text-purple-400"
                                                }`}
                                        >
                                            {member.fullName}
                                        </h3>

                                        {/* Position */}
                                        <h4 className="text-gray-800 text-lg md:text-xl font-semibold mb-1 group-hover:text-gray-700 transition-colors duration-300">
                                            {member.position}
                                        </h4>

                                        {/* Years in Role */}
                                        <p
                                            className={`text-sm mb-4 font-medium transition-colors duration-300 ${member.accentColor === "gold"
                                                ? "text-gold/80 group-hover:text-gold"
                                                : "text-custom-pink/80 group-hover:text-custom-pink"
                                                }`}
                                        >
                                            {member.yearsInRole}
                                        </p>

                                        {/* Bio */}
                                        <p className="text-gray-600 leading-relaxed text-sm md:text-base group-hover:text-gray-700 transition-colors duration-300">
                                            {member.bio}
                                        </p>

                                        {/* Decorative Element */}
                                        <div
                                            className={`mt-4 w-12 h-1 rounded-full bg-gradient-to-r transition-all duration-500 mx-auto sm:mx-0 ${member.accentColor === "gold"
                                                ? "from-gold to-yellow-600 group-hover:w-16"
                                                : "from-custom-pink to-purple-600 group-hover:w-16"
                                                }`}
                                        ></div>
                                    </div>
                                </div>

                                {/* Hover Glow Effect */}
                                <div
                                    className={`absolute inset-0 rounded-2xl opacity-0 group-hover:opacity-20 transition-opacity duration-500 ${member.accentColor === "gold" ? "bg-gold" : "bg-custom-pink"
                                        } blur-xl -z-10`}
                                ></div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Bottom Section */}
                <div
                    className={`mt-16 text-center transition-all duration-1000 delay-1000 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
                        }`}
                >
                    <div className="bg-gradient-to-r from-indigo-500 to-blue-600 rounded-3xl p-8 md:p-12 border border-gray-200 shadow-xl">
                        <div className="flex items-center justify-center mb-6">
                            <div className="w-1 h-12 bg-gradient-to-b from-gold to-custom-pink mr-4"></div>
                            <h2 className="text-3xl md:text-4xl font-bold text-white">
                                Committed to Excellence
                            </h2>
                        </div>

                        <p className="text-lg text-white/90 leading-relaxed mb-8 max-w-4xl mx-auto">
                            Our distinguished Advisory Board combines decades of expertise
                            in education, engineering, finance, and administration. Together,
                            they guide JRIIT's mission to provide world-class technical
                            education and create pathways to success for Tanzania's youth.
                        </p>

                        {/* Achievement Metrics */}
                        <div className="grid grid-cols-2 md:grid-cols-2 xl:grid-cols-4 gap-6 mt-8">
                            {[
                                { number: "25+", label: "Years Combined Experience" },
                                { number: "1000+", label: "Students Guided" },
                                { number: "15+", label: "Programs Developed" },
                                { number: "100%", label: "Commitment to Excellence" },
                            ].map((metric, index) => (
                                <div key={index} className="text-center group">
                                    <div
                                        className={`text-3xl md:text-4xl font-bold mb-2 transition-colors duration-300 ${index % 2 === 0
                                            ? "text-gold group-hover:text-yellow-400"
                                            : "text-custom-pink group-hover:text-purple-400"
                                            }`}
                                    >
                                        {metric.number}
                                    </div>
                                    <div className="text-white/80 text-sm md:text-base group-hover:text-white transition-colors duration-300">
                                        {metric.label}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                {/* Floating Decorative Elements */}
                <div className="fixed top-20 left-10 w-32 h-32 bg-gradient-to-br from-custom-pink/10 to-purple-200/10 rounded-full blur-3xl animate-pulse pointer-events-none"></div>
                <div
                    className="fixed bottom-20 left-10 w-24 h-24 bg-gradient-to-br from-gold/10 to-yellow-200/10 rounded-full blur-2xl animate-pulse pointer-events-none"
                    style={{ animationDelay: "1000ms" }}
                ></div>
            </div>

            <style>{`
        .bg-net-pattern {
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='40' height='40' viewBox='0 0 40 40'%3E%3Cg fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.03'%3E%3Cpath d='m0 40l40-40h-40v40zm40 0v-40h-40l40 40z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
        }
      `}</style>
        </div>
    );
};

export default BoardOfTrustees;
